import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../../../core/theme/theme.service';
import { LanguageService, SupportedLanguage } from '../../../services/language.service';

/**
 * Settings dropdown for unauthenticated contexts (auth pages).
 * Shows a gear icon that opens a panel with theme toggle and language switcher.
 */
@Component({
  selector: 'om-settings-menu',
  imports: [TranslateModule],
  templateUrl: './settings-menu.html',
  styleUrl: './settings-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsMenu {
  private readonly themeService = inject(ThemeService);
  private readonly languageService = inject(LanguageService);

  readonly color = input<'default' | 'primary'>('default');
  readonly isDark = this.themeService.isDark;
  readonly currentLanguage = this.languageService.currentLanguage;
  readonly isOpen = signal(false);
  readonly langs: SupportedLanguage[] = ['es', 'en', 'pt'];

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen.update((v) => !v);
  }

  closeMenu(): void {
    this.isOpen.set(false);
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }

  setLanguage(lang: SupportedLanguage): void {
    this.languageService.setLanguage(lang);
  }
}
